import { render, staticRenderFns } from "./Collective.vue?vue&type=template&id=0b91cc32"
import script from "./Collective.vue?vue&type=script&lang=js"
export * from "./Collective.vue?vue&type=script&lang=js"
import style0 from "./Collective.vue?vue&type=style&index=0&id=0b91cc32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports